import React, { useEffect, useState } from 'react'
import { HeartOutlined, StarOutlined } from '@ant-design/icons'
import { Link, useLocation, useNavigate} from 'react-router-dom'
import { FieldTimeOutlined,MenuUnfoldOutlined  } from '@ant-design/icons'
import { course_image_base_url, image_base_url } from '../../constants/Constant'
import useGetApi from '../../services/useGetApi'
import { images } from '../../assests/imageExport/ImageExports'
import usePost from '../../services/usePost'
import useCustomSnackbar from '../../helper/useCustomSnackbar'


const ListCourseCard = ({course}) => {
    const [isChatLoading, chatError, courseInfo, getCourseInfo] = useGetApi(
          `course/details/${course.id}`,
          [],
          true
    )

    const [isLoading, courseError, courseData, getCourseData] = useGetApi(`course/get?id=${course?.id}`, [], true);
    const [isUserLoading, userError, userData, getUserData] = useGetApi(`users/get`, [], true);
    const [isPostLoading, postError, postData] = usePost();
    const [rating,setRating] = useState(0)
    const [courseDataById,setCourseDataById] = useState()
    const navigate = useNavigate()
    const location = useLocation()
    const showSnackbar = useCustomSnackbar();
    
    useEffect(() => {
        getCourseInfo(`course/details/${course?.id}`)

    },[course.id])


    useEffect(() => {
        if (courseInfo && courseInfo.reviews) {
          const totalReviews = courseInfo.reviews.length;
          if (totalReviews > 0) {
            const averageRating = courseInfo.reviews.reduce((sum, review) => sum + review.rating, 0) / totalReviews;
            setRating(averageRating);
          } else {
            setRating(0); 
          }
        }
      }, [courseInfo])
    
      const navigateTo = () => {
        navigate(`/course/${course?.id}`)
      }

      useEffect(() => {
         if(courseData){
           setCourseDataById(courseData)
         }
      },[course?.id])

      const addWishlist = async() => {
           const data = {
                "userId": userData?.id,
                "course":courseDataById,
                "addedDate": new Date().toISOString()
           }

          const response = await postData(`wishlist/add?courseId=${course?.id}`,null,true,false)

          if(response){
            showSnackbar("success", "Course added to wishlist", {
              vertical: "top",
              horizontal: "right",
            });
          }
      }

      // useEffect(() => {
      //   console.log(location)
      // },[location])
  return (
    <div>

        {/* <Link to={`/course/${course?.id}`} className='link'> */}

        <div className='list_card'>
            <div className='left cursor-pointer' onClick={navigateTo}>
                <img src={course.thumbnail ?`${image_base_url}${course.thumbnail}` : images.broken_course_image} alt='course_image'
                  className='listCard_image'
                />
            </div>

            <div className='right'>

            <div className='top'>
                <div className='left cursor-pointer' onClick={navigateTo}>
                    <p className='course_title'>{course?.title}</p>
                    <p className='light_grey'>{rating} <StarOutlined /> ({courseInfo?.reviews?.length} Reviews) {course?.language || 'English'}</p>
                </div>
                <div>
                    {location.pathname !== '/user/my-wishlist' && <HeartOutlined onClick={addWishlist} />}
                </div>
            </div>

            <div className='middle'>
                <p className='content light_grey'>{course?.description} </p>
            </div>

            <div className='course_horizontal_line'></div>

            <div className='bottom'>
                <div>
                    <h3>₹0</h3>
                </div>
                <div className='light_grey'>
                    <p><MenuUnfoldOutlined /> {courseInfo?.sections?.length} Lessons <FieldTimeOutlined /> {course?.duration} mins</p>
                </div>
            </div>
            </div>
        </div>
        {/* </Link> */}
    </div>
  )
}

export default ListCourseCard
